import { render, staticRenderFns } from "./RqlPanelVocabulary.vue?vue&type=template&id=1f6f7a6f&"
import script from "./RqlPanelVocabulary.vue?vue&type=script&lang=js&"
export * from "./RqlPanelVocabulary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports